:host {
  display: block;
  font-family: var(--sc-font-sans);
}

:slotted(*) {
  margin: 0;
}
